import { isSameDay } from 'date-fns';

export const checkAftercareModalActive = (activeOnDate: string) => {
  const currentDate = new Date();
  const formattedActiveOnDate = new Date(activeOnDate);

  return formattedActiveOnDate < currentDate
    || isSameDay(formattedActiveOnDate, currentDate);
};
